var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewSmall = function SvgViewSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.784 14.813H5.625V5.625h9.16zm0 13.782H5.625v-9.188h9.16zm0 13.781H5.625v-9.188h9.16zM28.58 14.813h-9.159V5.625h9.159zm0 13.782h-9.159v-9.188h9.159zm0 13.781h-9.159v-9.188h9.159zm4.636-36.751h9.159v9.188h-9.159zm0 13.781h9.159v9.188h-9.159zm0 13.782h9.159v9.188h-9.159z"
  })))));
};
export default SvgViewSmall;